import { Props } from '../layout.type';

export const LayoutWithoutSidebar = ({ children }: Props) => {
  return (
    <div className='bg-primary min-h-screen'>
      <div className='max-w-7xl mx-auto pt-8 md:pt-14 transition-all duration-200'>{children}</div>
    </div>
  );
};
